import { Button, Col, Descriptions, Row, Space, Tag } from 'antd';
import styled from 'styled-components';
import Link from 'antd/lib/typography/Link';
import { Image } from 'antd';

import { styledDescriptions, styledTable } from '../styled/mixin';
import {
  corporateNumberFormatter,
  openKisconPage,
  phoneFormatter,
} from '../../util/utils';
import { EnterpriseType1, enterpriseType1Korean } from '../../modules/auth';
import Title from 'antd/lib/typography/Title';
import { Vendor } from '../../modules/vendors';
import AttachedFileListComponent from '../tasks/AttachedFileListComponent';
import { useState } from 'react';
import PDFViewModal2 from '../expenses/PDFViewModal2';

interface VendorCompanyDetailComponentProps {
  vendor: Vendor;
  downloadFile: (attachFileId: string, fileName: string) => void;
  moveToEditPage?: () => void;
}

const StyledDiv = styled.div`
  ${styledDescriptions}
  ${styledTable}
`;

function VendorCompanyDetailComponent({
  vendor,
  downloadFile,
  moveToEditPage,
}: VendorCompanyDetailComponentProps) {
  const [visible, setVisible] = useState(false);
  const [imageData, setImageData] = useState<any>();
  const [previewFileType, setPreviewFileType] = useState<string>('');

  const openImagePreview = (file: any) => {
    setImageData(file);
    setVisible(true);
    if (file.name.split('.').pop() === 'pdf') {
      setPreviewFileType('pdf');
    } else if (
      file.name.split('.').pop() === 'jpeg' ||
      file.name.split('.').pop() === 'jpg' ||
      file.name.split('.').pop() === 'png'
    ) {
      setPreviewFileType('image');
    } else {
      setPreviewFileType('');
    }
  };

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <Title level={5}>개요</Title>
        </Col>
        {moveToEditPage && (
          <Space>
            <Col>
              <Button
                size="small"
                onClick={() =>
                  openKisconPage(
                    vendor.application.general.name,
                    vendor.application.general.representativeName,
                  )
                }
              >
                키스콘 상세정보 열기
              </Button>
            </Col>

            {moveToEditPage && (
              <Col>
                <Button size="small" onClick={moveToEditPage}>
                  수정하기
                </Button>
              </Col>
            )}
          </Space>
        )}
      </Row>
      <Descriptions
        // title="회사정보"
        bordered
        column={3}
        size="small"
        // style={{ marginTop: '10px' }}
        // extra={
        //   <Space>
        //     <Button
        //       size="small"
        //       onClick={() =>
        //         openKisconPage(
        //           vendor.application.general.name,
        //           vendor.application.general.representativeName,
        //         )
        //       }
        //     >
        //       키스콘 상세정보 열기
        //     </Button>
        //     {moveToEditPage && (
        //       <Button size="small" onClick={moveToEditPage}>
        //         수정하기
        //       </Button>
        //     )}
        //   </Space>
        // }
      >
        <Descriptions.Item label="회사명">
          {vendor.application.general.name}
        </Descriptions.Item>
        <Descriptions.Item label="대표명">
          {vendor.application.general.representativeName}
        </Descriptions.Item>

        <Descriptions.Item label="회사주소">
          {vendor.application.general.companyAddress}
        </Descriptions.Item>
        <Descriptions.Item label="홈페이지" span={2}>
          <Link
            href={`${vendor.application.general.companyWebSite}`}
            target="_blank"
          >
            {vendor.application.general.companyWebSite}
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label="회사전화번호">
          {vendor.application.general.corporatePhoneNumber === undefined
            ? null
            : phoneFormatter(
                vendor.application.general.corporatePhoneNumber,
                1,
              )}
        </Descriptions.Item>
        <Descriptions.Item label="팩스번호">
          {vendor.application.general.companyFaxNumber === undefined
            ? null
            : phoneFormatter(vendor.application.general.companyFaxNumber, 1)}
        </Descriptions.Item>
        <Descriptions.Item label="사업자등록번호">
          {vendor.application.general.corporateNumber === undefined
            ? null
            : corporateNumberFormatter(
                vendor.application.general.corporateNumber,
              )}
        </Descriptions.Item>
        <Descriptions.Item label="대분류">
          {vendor.application.general.type1 === undefined
            ? null
            : enterpriseType1Korean[
                vendor.application.general.type1 as EnterpriseType1
              ]}
        </Descriptions.Item>

        {/* <Descriptions.Item label="보유면허">
          <>
            {vendor.application.general.type2 === undefined
              ? null
              : vendor.application.general.type2.map((tag: any, index: any) => (
                  <Tag key={index}>{tag}</Tag>
                ))}
          </>
        </Descriptions.Item> */}
        <Descriptions.Item label="주력분야">
          {vendor.application.general.type3 === undefined
            ? null
            : vendor.application.general.type3.map((tag: any, index: any) => (
                <Tag key={index}>{tag}</Tag>
              ))}
        </Descriptions.Item>
        {/* <Descriptions.Item label="시공능력평가액">
          {vendor.application.general.sipyeongAmount === undefined
            ? null
            : priceToString(vendor.application.general.sipyeongAmount)}
        </Descriptions.Item>
        <Descriptions.Item label="신용등급">
          {vendor.application.general.creditRating}
        </Descriptions.Item>
        <Descriptions.Item label="매출액">
          {vendor.application.general.revenue === undefined
            ? null
            : priceToString(vendor.application.general.revenue)}
        </Descriptions.Item> */}

        <Descriptions.Item label="은행명">
          {vendor.application.accountInfo.bankName}
        </Descriptions.Item>
        <Descriptions.Item label="예금주">
          {vendor.application.accountInfo.accountHolder}
        </Descriptions.Item>
        <Descriptions.Item label="계좌번호">
          {vendor.application.accountInfo.accountNumber}
        </Descriptions.Item>

        <Descriptions.Item label="담당자 이름">
          {vendor.application.contactPoint.name}
        </Descriptions.Item>
        <Descriptions.Item label="담당자 이메일">
          {vendor.application.contactPoint.email}
        </Descriptions.Item>
        <Descriptions.Item label="담당자 휴대전화번호">
          {vendor.application.contactPoint.personalPhoneNumber === undefined
            ? null
            : phoneFormatter(
                vendor.application.contactPoint.personalPhoneNumber,
                1,
              )}
        </Descriptions.Item>
        <Descriptions.Item label="공정">{vendor.gongjong}</Descriptions.Item>
        <Descriptions.Item label="용도">{vendor.category}</Descriptions.Item>
        <Descriptions.Item
          label="설명"
          style={{ whiteSpace: 'pre-wrap' }}
          span={2}
        >
          {vendor.description}
        </Descriptions.Item>
      </Descriptions>

      <div style={{ marginTop: '20px' }}>
        <AttachedFileListComponent
          attachedFiles={vendor.attachedFiles}
          downloadFile={downloadFile}
          openImagePreview={openImagePreview}
        />
      </div>

      {imageData && previewFileType === 'image' && (
        <Image
          width={200}
          style={{ display: 'none' }}
          preview={{
            visible,
            src: imageData?.url,
            onVisibleChange: (value) => {
              setVisible(value);
              setImageData(null);
              setPreviewFileType('');
            },
          }}
        />
      )}
      {imageData && previewFileType === 'pdf' && (
        <PDFViewModal2
          visible={!!imageData}
          url={imageData.url}
          onCancel={() => {
            setImageData(null);
            setPreviewFileType('');
          }}
          onDownload={() => downloadFile(imageData.id, imageData.name)}
        />
      )}
    </StyledDiv>
  );
}

export default VendorCompanyDetailComponent;
